import {
  Box,
  Button,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { toggleOnboarding } from "../../../features/onboarding/onboarding.slice";
import { useNavigate } from "react-router-dom";
import ChromeIcon from "../../../assets/chromeIcon.svg";
import Prfot from "../../../assets/prfot.svg";
import Hazmat from "../../../assets/hazmat.svg";
import Buybix from "../../../assets/buybix.svg";

const FEATURES = [
  {
    image: Prfot,
    title: "Profit Calculator",
    description:
      "Know your margins instantly",
  },
  {
    image: Hazmat,
    title: "IP & Hazmat Alerts",
    description: "Spot restricted items before listing",
  },
  {
    image: Buybix,
    title: "Buy Box Analysis",
    description:
      "Win smarter with better data",
  },
];

export const WebSignupOnboarding = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { data: pricingPlans } = useAppSelector((state) => state.pricingPlans);
  const theme = useTheme();
  const mdDown = useMediaQuery(theme.breakpoints.down("md"));
  const smDown = useMediaQuery(theme.breakpoints.down("sm"));

  // const plans = pricingPlans.map((plan) =>
  //   plan.name.toLowerCase() === "free"
  //     ? {
  //       ...plan,
  //       onChange() {
  //         dispatch(toggleOnboarding(false));
  //       },
  //     }
  //     : plan,
  // );

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
      <Typography
        textAlign="center"
        fontSize={"28px"}
        fontWeight={700}
        letterSpacing={"-0.75px"}
        color={"#1C1C1C"}
      >
        Unlock Powerful Product Insights on Amazon
      </Typography>
      <Typography
        sx={{
          color: "#444444",
          fontWeight: 400,
          fontSize: "18px",
          textAlign: "center",
        }}
      >
        Add SellerScout Chrome Extension — Analyze products instantly while you browse.
      </Typography>
      <Typography
        sx={{
          color: "#444444",
          fontWeight: 400,
          fontSize: "16px",
          textAlign: "center",
        }}
      >
        Calculate profits in real time, get automatic IP/Hazmat warnings, access buy box insights
        <br />
        and much more — all from the Amazon product page.

      </Typography>
      <Button
        variant="contained"
        onClick={() =>
          window.open(
            "https://chromewebstore.google.com/detail/sellerscout-amazon-produc/jalhmaecfpoocghfaocbaehfhobagnhh?hl=en",
            "_blank",
          )
        }
        sx={{
          width: "248.73px",
          height: "48px",
          fontWeight: 600,
          fontSize: "15.3px",
          mt: 4,
          cursor: "pointer",
          borderRadius: "8px",
          gap: "10px"
        }}
      >
        <img src={ChromeIcon} alt="ChromeIcon" />Install Free on Chrome
      </Button>

      <Box
        display="flex"
        flexDirection={mdDown ? "column" : "row"}
        gap="60px"
        justifyContent="center"
        alignItems="flex-start"
        mt={4}
      >
        {FEATURES.map((feature, index) => (
          <Stack
            alignItems="center"
            justifyContent="center"
          >
            <Box
              border="1px solid #181D1F26"
              borderRadius="12px"
              textAlign="center"
              height="193px"
              width="275px"
            >
              <Box
                sx={{
                  height: "90px",
                  alignItems: "center",
                  mt: 2,
                }}
              >
                <img src={feature.image} />
              </Box>
              <Typography
                sx={{
                  color: "#1C1C1C",
                  fontWeight: 700,
                  fontSize: "18px",
                  mt: 1,
                }}
              >
                {feature.title}
              </Typography>
              <Typography
                sx={{
                  color: "#555555",
                  fontWeight: 400,
                  fontSize: "14px",
                  mt: 1,
                }}
              >
                {feature.description}
              </Typography>
            </Box>
          </Stack>
        ))}
      </Box>
      <Typography
        sx={{
          color: "#444444",
          fontWeight: 400,
          fontSize: "16px",
          textAlign: "center",
          mt: 4,
        }}
      >
        ⭐️ 4.9 / 5 — Trusted by 20,000+ Amazon sellers
      </Typography>
      <Typography
        sx={{
          color: "#555555",
          fontWeight: 400,
          fontSize: "14px",
        }}
      >
        No credit card required
      </Typography>
      <Typography
        sx={{
          color: "#000000",
          fontWeight: 600,
          fontSize: "14px",
          fontStyle: "bold",
          mt: 2,
        }}
      >
        Already installed the extension?
      </Typography>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        gap="16px"
        mt={1}
      >
        <Button
          variant="outlined"
          sx={{
            width: "248.73px",
            height: "48px",
            fontSize: "15.3px",
            paddingX: "24px",
            fontWeight: 600,
            border: "1px solid #0F56CA",
            borderRadius: "8px",
          }}
          onClick={() => navigate("/")}
        >
          Continue Setup
        </Button>
      </Box>
    </Box>
  );
};

export default WebSignupOnboarding;
